import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { confirmEmail } from "../../../api/endpoints/AuthEndpoints";

export default function useConfirmEmail() {
  return useMutation<void, AxiosError, { token: string }>({
    mutationKey: ["confirm-email"],
    mutationFn: ({ token }) => confirmEmail(token),
  });
}
